import * as fetch from '../fetch'

export function frontend_encode(data){
  return fetch.node_public_fetch({
    url: '/frontend/encode',
    method: 'post',
    data
  });
}

export function frontend_less(data){
  return fetch.node_public_fetch({
    url: '/frontend/less',
    method: 'post',
    data
  });
}
